﻿import { request, EMISSION_BASE, ORGANISATION_BASE } from "@/api/client";
import { fetchBusinessUnits } from "@/features/facilities/api/businessUnitService";
import type { BusinessUnitOption } from "@/features/facilities/api/businessUnitService";
import type {
  GeneratedReportListResponse,
  ReportPayload,
  ReportSettingsResponse,
} from "../types/reports";

function downloadReport(url: string, payload: unknown): Promise<ArrayBuffer> {
  return request("post", url, {
    data: payload,
    timeout: 120_000,
    responseType: "arraybuffer",
    unwrap: false,
  });
}

export function generateFrameworkReport(
  payload: ReportPayload,
): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/report`, {
    ...payload,
    protocol: payload.protocol ?? "iso",
  });
}

export function generateGRIYearwiseReport(
  payload: ReportPayload,
): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/gri-year-wise`, payload);
}

export function downloadGRIIndex(year: number): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/gri-index-report`, { year });
}

export function downloadBRSRDataReport(
  payload: ReportPayload,
): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/brsr-data`, payload);
}

export function downloadIFRSS2DataReport(
  payload: ReportPayload,
): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/ifrs-data`, payload);
}

export function downloadIFRSS1DataReport(
  payload: ReportPayload,
): Promise<ArrayBuffer> {
  return downloadReport(`${EMISSION_BASE}/ifrs-s1-data`, payload);
}

export function getReportSettings(
  fetchReports = true,
): Promise<ReportSettingsResponse> {
  return request("get", ORGANISATION_BASE + "/companypreferences", {
    params: { fetchReports },
    timeout: 30_000,
    unwrap: false,
  });
}

export async function fetchFacilities(): Promise<BusinessUnitOption[]> {
  const { businessUnits } = await fetchBusinessUnits();
  return businessUnits;
}

export function listGeneratedReports(params: {
  page?: number;
  limit?: number;
}): Promise<GeneratedReportListResponse> {
  return request("get", `${EMISSION_BASE}/reports`, {
    params,
    timeout: 30_000,
    unwrap: false,
  });
}

export function reDownloadReport(id: number): Promise<ArrayBuffer> {
  return request("get", `${EMISSION_BASE}/reports/${id}/download`, {
    timeout: 120_000,
    responseType: "arraybuffer",
    unwrap: false,
  });
}
